import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/supporter/$supporterId/financial-reports/transactions/details/$version")({
  beforeLoad: () => ({
    breadcrumb: "Details",
  }),
  parseParams: ({ version, ...params }) => {
    const num = +version;
    if (!isFinite(num)) {
      throw new Error("Invalid wallet version");
    }
    return {
      ...params,
      version: Math.round(num),
    };
  },
  stringifyParams: ({ version, ...params }) => ({
    ...params,
    version: version.toString(),
  }),
  component: lazyRouteComponent(() => import("./+VersionDetails")),
});
